module.exports = __webpack_public_path__ + "static/media/homepage-bg.91c8d1af.svg";